import Permissions, { usePermissions } from '@app/src/auth/permissions'
import type { NavigationItemProps } from '@app/src/components/Navigation/VerticalMenu/NavigationItems/NavigationItems'
import { insertIf } from '@app/src/utils/helpersTs'
import navigationLinks from '@app/src/wf-constants/navigationLinks'
import useShowScreenedRequests from '@app/src/hooks/useShowScreenedRequests'
import React from 'react'
import { useIntl } from 'react-intl'
import type { MenuWrapperProps } from './MenuWrapper'
import MenuWrapper from './MenuWrapper'

const RequestMenu: React.FC<NavigationItemProps> = ({ icon }) => {
  const { formatMessage } = useIntl()
  const { hasPermission } = usePermissions()
  const isTransparency = hasPermission(Permissions.TRANSPARENCY_USER)
  const showScreenedRequests = useShowScreenedRequests()

  const menuItems: MenuWrapperProps['menuItems'] = [
    ...insertIf(showScreenedRequests, {
      title: formatMessage({ id: 'navbar.screenedRequests' }),
      link: navigationLinks.screenedResponses,
      permission: [
        Permissions.TRANSPARENCY_USER,
        Permissions.SOURCING_USER,
        Permissions.INVESTMENT_USER,
        Permissions.FINANCE_USER,
      ],
    }),
    {
      title: formatMessage({ id: isTransparency ? 'navbar.receivedRequests' : 'navbar.sentRequests' }),
      link: navigationLinks.requests,
      permission: [
        Permissions.TRANSPARENCY_USER,
        Permissions.SOURCING_USER,
        Permissions.INVESTMENT_USER,
        Permissions.FINANCE_USER,
      ],
    },
    {
      title: formatMessage({ id: 'navbar.responses' }),
      link: navigationLinks.responses,
      permission: [
        Permissions.TRANSPARENCY_USER,
        Permissions.SOURCING_USER,
        Permissions.INVESTMENT_USER,
        Permissions.FINANCE_USER,
      ],
    },
  ]

  if (!isTransparency) {
    menuItems.unshift({
      title: formatMessage({ id: 'navbar.manageRequestOverview' }),
      link: navigationLinks.manageRequestOverview,
      permission: [
        Permissions.TRANSPARENCY_USER,
        Permissions.SOURCING_USER,
        Permissions.INVESTMENT_USER,
        Permissions.FINANCE_USER,
      ],
    })
  }

  return <MenuWrapper icon={icon} menuItems={menuItems} title={formatMessage({ id: 'navbar.manageRequests' })} />
}

export default RequestMenu
